module.exports = __webpack_public_path__ + "static/media/4col-X-10in_Eid_Press_2015_01.rev.b.1161c4c8.jpg";